import { defineComponent, computed } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        frames: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        currentFrame: {
            type: Number
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var findFrameIndex = computed(function() {
            return props.frames.findIndex(function(val) {
                return val.id === props.currentFrame;
            });
        });
        var previousFrame = function() {
            if (!findFrameIndex.value) {
                return;
            }
            emit("update:currentFrame", props.frames[findFrameIndex.value - 1].id);
        };
        var nextFrame = function() {
            if (findFrameIndex.value === props.frames.length - 1) {
                return;
            }
            emit("update:currentFrame", props.frames[findFrameIndex.value + 1].id);
        };
        return {
            previousFrame: previousFrame,
            nextFrame: nextFrame,
            findFrameIndex: findFrameIndex
        };
    }
});
